module.exports = "/wp-content/plugins/farmacy/assets/js/images/card-interac-md-529271d7a0b60842ada6148e2deb6e6d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-payment/img/card-interac-md.png
 ** module id = 397
 ** module chunks = 1 9 15 84
 **/